// src/components/strumenti/PreventivoConsuntivo.js — W442. Scostamento tra preventivo e consuntivo
import React from "react";
import { useCampi, Campo, Griglia, Risultato, Formula, Azzera, euro, fmt } from "./UiStrumento";
import { scostamento } from "../../utils/calcoliStrumenti";

export default function PreventivoConsuntivo() {
  const { v, set, n, azzera } = useCampi({ prev:"", cons:"" });
  const r = v.prev !== "" && v.cons !== "" ? scostamento(n("prev"), n("cons")) : null;
  const sopra = r && r.diff > 0;
  return (
    <div>
      <Griglia colonne={2}>
        <Campo etichetta="Preventivo (€)" valore={v.prev} onChange={set("prev")} placeholder="Es. 10000"/>
        <Campo etichetta="Consuntivo (€)" valore={v.cons} onChange={set("cons")} placeholder="Es. 11500"/>
      </Griglia>
      <Risultato settore="finanza" titolo={r ? (r.diff === 0 ? "In linea con il preventivo" : sopra ? "Speso più del previsto" : "Speso meno del previsto") : "Scostamento"}
        valore={r ? `${r.diff > 0 ? "+" : ""}${euro(r.diff)}` : "—"}
        righe={r ? [["Scostamento %", r.pct === null ? "—" : `${r.pct > 0 ? "+" : ""}${fmt(r.pct, 2)}%`], ["Consuntivo su preventivo", r.pct === null ? "—" : fmt(100 + r.pct, 2) + "%"]] : []}/>
      <Formula>Scostamento = consuntivo − preventivo; % = scostamento ÷ preventivo × 100. Positivo = si è speso più del previsto. Confronta importi omogenei (entrambi IVA esclusa).</Formula>
      <Azzera onClick={azzera}/>
    </div>
  );
}
